import { useState, useCallback, useEffect } from 'react';
import { replacePlaceholders } from '../tools/tmntHelpers';
import AnalyticsTriggers from '../analytics/analyticsTriggers';

const getUnselectedSizeErrorMessage = ({
  secondarySizeArray,
  verifiedCriteria,
  primarySizeGroupHeading,
  secondarySizeGroupHeading,
}, {
  selectSizeError,
  selectSpecificSizeFieldError,
}) => {
  const productHasSecondarySize = secondarySizeArray.length > 0;
  const hasPrimarySizeSelected = !!verifiedCriteria.primarySize;
  const hasSecondarySizeSelected = !!verifiedCriteria.secondarySize;
  const productHasSecondarySizeOnlyOneSizeFieldUnselected = productHasSecondarySize
      && (
        (hasPrimarySizeSelected && !hasSecondarySizeSelected)
        || (!hasPrimarySizeSelected && hasSecondarySizeSelected)
      );

  let errorObject = { ...selectSizeError };

  if (productHasSecondarySizeOnlyOneSizeFieldUnselected) {
    errorObject = { ...selectSpecificSizeFieldError };
    const unselectedFieldHeading = !hasPrimarySizeSelected
      ? primarySizeGroupHeading : secondarySizeGroupHeading;
    errorObject.value = replacePlaceholders(errorObject.value, { 0: unselectedFieldHeading });
  }

  return errorObject;
};

export default function useAddToBagErrorHandler(collectionData, tmntData, resetATBButton) {
  const [addToBagError, setAddToBagError] = useState(null);

  const handleFormError = useCallback((errorMessage) => {
    if (resetATBButton) resetATBButton();
    setAddToBagError(errorMessage || getUnselectedSizeErrorMessage(collectionData, tmntData));
  }, [resetATBButton, collectionData, tmntData]);

  useEffect(() => {
    if (addToBagError && addToBagError?.value) {
      AnalyticsTriggers.universalClick('add to bag error', addToBagError?.value);
    }
  }, [addToBagError]);

  return { addToBagError, setAddToBagError, handleFormError };
}
